import {ExportMenu} from './export/exportMenu';
import {ImportMenu} from './import/importMenu';
import {Constants as constants} from '../config/constants';
import * as d3 from 'd3';
import {FileMapping} from '@/types/data';

export class MenuInitializer {
    private menus = {
        export: null as ExportMenu | null,
        import: null as ImportMenu | null
    };

    constructor(private files: FileMapping[]) {
    }

    public init() {
        this.initializeContainers();
        this.initializeMenus();
    }

    private initializeContainers() {
        d3.select(constants.svgParentSelector)
            .append('div')
            .attr('id', constants.exportMenuId);

        d3.select(constants.svgParentSelector)
            .append('div')
            .attr('id', constants.importMenuId);
    }

    private initializeMenus() {
        this.menus.export = new ExportMenu();
        this.menus.import = new ImportMenu(this.files);
    }
}
